export const PAGINATION_PAGES_COUNT = 5
